import { stateParamsSelectorFactory } from '@Selectors/StateParamsSelectors';

export const breadcrumbBaseParams = stateParamsSelectorFactory(['context', 'databaseId', 'sort', 'order', 'searchId']);

export const searchFilterBaseParams = stateParamsSelectorFactory(['searchId', 'context', 'databaseId', 'resultName', 'hitSetKey']);

export const searchFilterCitationsAdditionalParams = stateParamsSelectorFactory(['sort', 'order']);

export const nextStateBaseParams = stateParamsSelectorFactory(['context', 'query', 'databaseId']);
